
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, Search, MapPin, ArrowRight } from "lucide-react";
import { popularLocations, otherLocations } from "../navData";
import Home from "./Home"; // Import the custom Home icon component

const MobileFindHomeSection = ({ onClose }: { onClose: () => void }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between py-3 border-b w-full text-left"
      >
        <div className="flex items-center">
          <Home className="h-5 w-5 text-grandpal-green mr-3" />
          <h3 className="font-medium text-gray-800 font-lora">Find a Home</h3>
        </div>
        <ChevronDown 
          className={`h-5 w-5 text-grandpal-green transition-transform duration-200 ${
            isOpen ? 'rotate-180' : 'rotate-0'
          }`}
        />
      </button>
      {isOpen && (
        <div className="py-4 pl-4 space-y-4 animate-fade-in">
          <h4 className="text-xs uppercase tracking-wide text-grandpal-green font-medium mb-2">Search options</h4>
          <div className="space-y-3">
            <Link
              to="/nursing-homes"
              className="flex items-center gap-2 py-1.5 text-gray-700 hover:text-grandpal-green transition-colors"
              onClick={onClose}
            >
              <Search className="h-4 w-4 text-grandpal-green" />
              <span>Search all homes</span>
            </Link>
            <Link
              to="/nursing-homes?map=true"
              className="flex items-center gap-2 py-1.5 text-gray-700 hover:text-grandpal-green transition-colors"
              onClick={onClose}
            >
              <MapPin className="h-4 w-4 text-grandpal-green" />
              <span>Find homes by location</span>
            </Link>
          </div>

          <h4 className="text-xs uppercase tracking-wide text-grandpal-green font-medium my-2">Popular locations</h4>
          <div className="grid grid-cols-2 gap-x-4 gap-y-3">
            {popularLocations.map((item) => (
              <Link
                key={item.title}
                to={item.path}
                className="block py-1.5 text-gray-700 hover:text-grandpal-green transition-colors"
                onClick={onClose}
              >
                {item.title}
              </Link>
            ))}
            {otherLocations.map((item) => (
              <Link
                key={item.title}
                to={item.path}
                className="block py-1.5 text-gray-700 hover:text-grandpal-green transition-colors"
                onClick={onClose}
              >
                {item.title}
              </Link>
            ))}
          </div>
          
          <Link
            to="/waitlist"
            className="flex items-center text-grandpal-green font-medium group mt-2"
            onClick={onClose}
          >
            Join a Waitlist
            <ArrowRight className="ml-1.5 h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      )}
    </div>
  );
};

export default MobileFindHomeSection;
